<template>
    <div class="w-100" style="height: 44vh;">
        
    </div>
</template>

<script>
import HTTPRequest from '../controllers/httpRequest.js'
import secureStorage from '../controllers/secureStorage.js'
import { mapState, mapActions } from 'vuex'

var options = {}
var browserId = "" 
var component_x;
export default {
    computed: {
        ...mapState(['loggedIn', 'endPoint', 'userEmail']),
    },
    mounted: async function(){
        this.$emit('changeAuthLayoutSpinning',true)
        component_x = this;
        secureStorage.setItem("developerMode", false);
        var hostname = window.location.hostname
        var pathname = window.location.pathname
        if(pathname=="/"){
            try {
                var check_domain = await HTTPRequest.getRequest(component_x.endPoint + 'sales_channel_products/check_domain?url='+hostname, null)
                if(check_domain.url!=undefined){
                    pathname = check_domain.url.replace(hostname,"")
                }
            }catch (e) {
                component_x.$emit('changeAuthLayoutSpinning',false)
                this.$router.push('login');
            }
        }
        if (pathname !="/" && pathname!="" && pathname!=null){
            var storeId = pathname.replace("/","")
            var id = storeId.replace("os","")
            component_x.storeId = storeId
            if (!isNaN(id)){
                var response = await HTTPRequest.getRequest(component_x.endPoint + 'sales_channel_products/get_online_store_details?id='+id, null)
                if (response["sales_channel_details"]!=undefined){
                    component_x.accountName = response["account"]["account_name"];
                    component_x.email = response["account"]["account_name"]+"_online_store_user@bxi.com"
                    component_x.password = "password"
                    secureStorage.setItem("email", component_x.email)
                    var access_token = secureStorage.getItem("refreshToken")
                    if(access_token == undefined){
                        var post_request = await HTTPRequest.postRequest(component_x.endPoint.split("/api")[0] + '/oauth/token', null, {account_name: component_x.accountName, email: component_x.email, password: component_x.password, grant_type: "password"})
                        if(post_request["error"] == undefined){
                            secureStorage.setItem("accessToken", post_request["access_token"]);
                            secureStorage.setItem("refreshToken", post_request["refresh_token"]);
                        }
                    }
                    secureStorage.setItem("SalesChannelDetails", response["sales_channel_details"])
                    secureStorage.setItem("collections",response["collections"])
                    secureStorage.setItem("accountName", component_x.accountName)
                    secureStorage.setItem("accountCompanyName",  response["account"]["company_name"])
                    var autoLogin = secureStorage.getItem("ecomLoggedIn")
                    if(autoLogin == true){
                        component_x.$emit('changeAuthLayoutSpinning',false)
                        if(component_x.$route.params.returnUrl!=null){
                            component_x.$router.push({ name: component_x.$route.params.returnUrl, params:{ storeId:component_x.$route.params.storeId }})
                        }else{
                            component_x.$router.push({ name: 'store', params:{ storeId:storeId }})
                        }
                    }else{
                        component_x.authenticateOnlineStoreUser()
                    }
                }
            }
        }else{
            component_x.$emit('changeAuthLayoutSpinning',false)
            this.$router.push('login');
        }
    },
    data: function() {
        return {
            email: '',
            password: '',
            accountName: '',
            errorMessage: null,
            loggingIn: false,
            storeId:null,
        }
    },
    methods: {
        ...mapActions(['updateLoggedInStatus', 'updateUserEmail']),
        authenticateOnlineStoreUser: async function() {
            var passwordResetPayload = {email: this.email, account_name: this.accountName}
            var post_request = await HTTPRequest.postRequest(this.endPoint + 'users/validate', null, passwordResetPayload)
            if(post_request["error"] != undefined){
            } else {
                var bodyFormData = new FormData();
                bodyFormData.set('email', this.email);
                bodyFormData.append('password', this.password);
                bodyFormData.append('account_name', this.accountName); 
                bodyFormData.append('grant_type', 'password');
                var access_token = secureStorage.getItem("refreshToken")
                if(access_token == undefined){
                    post_request = await HTTPRequest.postRequest(this.endPoint.split("/api")[0] + '/oauth/token', null, {account_name: this.accountName, email: this.email, password: this.password, grant_type: "password"})
                    if(post_request["error"] == undefined){
                        secureStorage.setItem("accessToken", post_request["access_token"]);
                        secureStorage.setItem("refreshToken", post_request["refresh_token"]);
                    }
                } else {
                    var userName = secureStorage.getItem("userName") 
                    var email = secureStorage.getItem("email")
                    if(this.email == userName || this.email == email){
                        var check_password = await HTTPRequest.postRequest(this.endPoint + "/users/validate_password", null, {account_name: this.accountName, email: this.email, password: this.password})
                        if(check_password["error"] == undefined){
                            post_request = {success: "Password okay"}
                        }
                        else{
                            this.errorMessage = "It seems you've entered a wrong password. Please try again."
                            post_request = {error: "Invalid password"}
                        }   
                    } else {
                        post_request = await HTTPRequest.postRequest(this.endPoint.split("/api")[0] + '/oauth/token', null, {account_name: this.accountName, email: this.email, password: this.password, grant_type: "password"})
                        if(post_request["error"] == undefined){
                            secureStorage.setItem("accessToken", post_request["access_token"]);
                            secureStorage.setItem("refreshToken", post_request["refresh_token"]);
                        }
                    }
                }
                if(post_request["error"] == undefined) {
                    secureStorage.setItem("ecomLoggedIn", true)
                    component_x.$emit('changeAuthLayoutSpinning',false)
                    if(component_x.$route.params.returnUrl!=null){
                        component_x.$router.push({ name: component_x.$route.params.returnUrl,params:{ storeId:component_x.$route.params.storeId }})
                    }else{
                        component_x.$router.push({ name: 'store',params:{ storeId:this.storeId }})
                    }
                } else {
                    component_x.errorMessage = post_request["error"]
                    secureStorage.removeItem("accessToken");
                    secureStorage.removeItem("refreshToken");
                }
            }
        },
    }
}
</script>

<style>
.ant-spin {
    max-height: 100%!important;
}
</style>
